import { render } from "./BuyCapacity.vue?vue&type=template&id=1e0f5ff9&scoped=true"
import script from "./BuyCapacity.vue?vue&type=script&lang=js"
export * from "./BuyCapacity.vue?vue&type=script&lang=js"

import "./BuyCapacity.vue?vue&type=style&index=0&id=1e0f5ff9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0f5ff9"]])

export default __exports__